<template>
    <v-dialog v-model="mostrar">
        <v-card>
            <v-toolbar dark color="blue-grey">Caja</v-toolbar>
            <v-card-text>
                <v-row class="mt-2">
                    <v-col>
                        <v-text-field label="Número" v-model="caja.numero" readonly></v-text-field>
                        <v-text-field label="Tipo documental" v-model="caja.tipoDocumental" readonly></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Fecha de inicio"
                            :value="new Date(caja.fechaInicio).toLocaleDateString('en-GB')" readonly></v-text-field>
                        <v-text-field label="Dependencia generadora" v-model="caja.dependenciaGeneradora.nombre"
                            readonly></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Fecha de fin" :value="new Date(caja.fechaFin).toLocaleDateString('en-GB')"
                            readonly></v-text-field>
                        <v-text-field label="Unidad administrativa" v-model="caja.unidadAdministrativa.nombre"
                            readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-system-bar color="blue-grey rounded rounded-b-0" dark>
                    <span class="white--text subtitle-2">Expedientes</span>
                    <v-spacer></v-spacer>
                    <span class="white--text subtitle-2">Total: {{ caja.expedientes.length }}</span>
                    <!-- <v-btn icon color="white"><v-icon>mdi-plus</v-icon></v-btn> -->
                </v-system-bar>
                <v-list class=" grey lighten-4 rounded-t-0 overflow-y-auto" subheader tile max-height="335">
                    <v-list-item v-for="expediente in caja.expedientes" :key="expediente._id" link two-lines>
                        <v-list-item-content @click="verExpediente(expediente)">
                            <v-list-item-title>{{ expediente.clave }}</v-list-item-title>
                            <span class="grey--text text--darken-2"> {{ expediente.unidadAdministrativa.nombre }} - {{ expediente.serie.nombre
                                }} -
                                {{ expediente.subserie.nombre }}</span>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-row no-gutters class="pb-5 pr-6" justify="end">
                <v-btn color="blue-grey" outlined @click="$emit('cancelar');">Cerrar</v-btn>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { getOficoPadre } from "./archivo.service"

export default {
    name: 'OficiosConsultarCaja',
    props: {
        caja: {
            type: Object,
            required: true,
        },
        mostrar: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            expedienteLocal: {},
        };
    },

    mounted() {
    },

    methods: {
        async verExpediente(expediente) {
            try {
                const { _id } = expediente;
                const serverResponse = await getOficoPadre(_id);
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje)
                const { oficio } = serverResponse;
                this.$router.push(`/oficios/${oficio.type}/${oficio._id}`);
            } catch (error) {
                this.$notificarError(error);
            }
        },
    },
};
</script>